import React from 'react';
import { useRouter } from './Router';

export default function Route(props) {
  const router = useRouter();

  const route = router.route;

  if (route === false) {
    // If false, router didn't has time to run componentDidMount
    // Waiting for it
    return null;
  }
  let renderedRoute = route;
  Array.from(Array(props.deep || 0)).forEach(() => {
    renderedRoute = renderedRoute.subRoute
  });

  if (renderedRoute) {
    const RouteComponent = renderedRoute.component;
    return (
      <RouteComponent {...props} route={renderedRoute} />
    );
  } else {
    if (props.notFound) {
      const Component = props.notFound;
      return <Component />
    } else {
      return (
        <div>NOT FOUND</div>
      );
    }
  }
};
